import { useNavigate } from 'react-router-dom';
import Logo from '../assets/images/WocaiCai_3D Renderred_logo.png';
import socket from '../socket';

const Header = ({ gameSyncData, player }) => {
  const navigate = useNavigate();

  const goHome = () => {
    navigate('/');

    if (gameSyncData?.roomId && player?.id) {
      socket.emit('go-lobby', {
        roomId: gameSyncData.roomId,
        playerId: player.id,
      });
    }
  };


  return (
    <header className="fixed top-0 left-0 w-full bg-[#033591] py-4 pl-8 pr-16 flex items-center justify-between shadow-md h-80px] z-50">
      {/* Left: Logo */}
      <button onClick={goHome}>
        <img src={Logo} alt="Logo" className="h-10 w-auto" />
      </button>

      {/* Right: User icon */}
      <div className="flex items-center space-x-4">
        


        <button
            onClick={goHome}
            className="text-white border-2 border-white px-4 py-1 rounded-lg transition duration-300 hover:bg-white hover:text-[#143693]"
          >
            Lobby
        </button>



        {/* Option 1: Use an icon 
          <User className="text-white h-6 w-6 cursor-pointer" />
        */}

        {/* Option 2: Use a user image */}
        {/* <img src="/path-to-user-avatar.jpg" alt="User" className="h-8 w-8 rounded-full object-cover" /> */}
      </div>
    </header>
  );
};

export default Header;
